import { Device } from '../../../../types/Device';
import { PTTMessage } from '../api/usePttMessageStore';

export const getDeviceName = (devices: Device[], sender_uid: string): Device | undefined => {
    if (!devices || !sender_uid) return undefined;
    return devices.find((d) => d.UID === sender_uid || d.DID === sender_uid);
};
